import { PasteTypes } from '../types/types';

type I18nKey = 'pasteTypeIframe' | 'pasteTypeLink' | 'pasteTypeWikiOld' | 'pasteTypeWiki';

export const pasteTypesRadio: { value: PasteTypes; i18nKey: I18nKey }[] = [
    { value: 'wikiMarkdown', i18nKey: 'pasteTypeWiki' },
    { value: 'playerUrl', i18nKey: 'pasteTypeLink' },
    { value: 'iframe', i18nKey: 'pasteTypeIframe' },
    { value: 'wiki', i18nKey: 'pasteTypeWikiOld' },
];
